import(/* webpackMode: "eager" */ "/Users/gopal/Sushmita/aarohi/app/vendors/page.tsx");
